import * as React from 'react'


const Fonts = (props: { fonts: any }) => (
    <style>
        @font-face {'{'}
        font-family: 'Custom';
        src: url({props.fonts.regular});
        font-weight: 400;
        {'}'}
        @font-face {'{'}
        font-family: 'Custom';
        src: url({props.fonts.light});
        font-weight: 200;
        {'}'}
        @font-face {'{'}
        font-family: 'Custom';
        src: url({props.fonts.medium});
        font-weight: 600;
        {'}'}
        @font-face {'{'}
        font-family: 'Custom';
        src: url({props.fonts.bold});
        font-weight: 800;
        {'}'}
        @font-face {'{'}
        font-family: 'tourismcta';
        src: url({props.fonts.tourismCta});
        font-weight: 600;
        {'}'}
        @font-face {'{'}
        font-family: 'tourismbody';
        src: url({props.fonts.tourismBody});
        font-weight: 600;
        {'}'}
    </style>
)

export default Fonts



// WEBPACK FOOTER //
// ./src/components/Fonts.tsx